module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.groupsLength != 0) ? _c('div', {
    staticClass: "groupsManage clearfix"
  }, [_c('div', {
    staticClass: "createGroup clearfix"
  }, [_c('span', [_vm._v("共\n        "), _c('em', [_vm._v(_vm._s(_vm.groupsLength))]), _vm._v(" 个小组")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.addGroup
    }
  }, [_vm._v("新建小组")])]), _vm._v(" "), _vm._l((_vm.groups), function(item, index) {
    return (item.title != '未分组') ? _c('div', {
      key: index,
      staticClass: "groupsList"
    }, [_c('p', [_c('span', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('ul', {
      staticClass: "fr"
    }, [_c('li', [_c('img', {
      attrs: {
        "src": require("../../assets/img/classEdit-icon.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "edit fr",
      on: {
        "click": function($event) {
          _vm.edit(index)
        }
      }
    }, [_vm._v("编辑")])]), _vm._v(" "), _c('li', [_c('img', {
      attrs: {
        "src": require("../../assets/img/delete-icon.png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "delete fr",
      on: {
        "click": function($event) {
          _vm.delTeam(index)
        }
      }
    }, [_vm._v("删除")])])])]), _vm._v(" "), _c('div', {
      staticClass: "stuList"
    }, [_c('ul', _vm._l((item.data), function(sitem, sindex) {
      return _c('li', {
        key: sindex
      }, [_vm._v(_vm._s(sitem.userName))])
    }))])]) : _vm._e()
  })], 2) : _c('div', {
    staticClass: "noClassList"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("该班级下还没有小组，赶紧添加一个吧")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.addGroup
    }
  }, [_vm._v("新建小组")])]), _vm._v(" "), _c('notice', {
    attrs: {
      "params": _vm.params,
      "isNotice": _vm.isNotice
    },
    on: {
      "isConfirm": _vm.isConfirm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31ffdc9a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/classManage/group.vue
// module id = 1178
// module chunks = 1